/** Planning tab for a specific model on the admin side. */
import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import PlanningCalendar from "../../../components/planning/PlanningCalendar";
import { planningAdminApi } from "../../../api/planning";

export default function AdminModelPlanning() {
  const { modelId } = useOutletContext();
  const api = useMemo(
    () => ({
      list: (range) => planningAdminApi.list(modelId, range),
      create: (data) => planningAdminApi.create(modelId, data),
      update: planningAdminApi.update,
      remove: planningAdminApi.remove,
    }),
    [modelId],
  );

  return (
    <div data-testid="admin-model-planning-tab" className="space-y-4">
      <PlanningCalendar
        api={api}
        canEditVisibility
        testId="admin-model-planning-calendar"
      />
    </div>
  );
}
